import React from "react";
import { Modal, Button, message } from "antd";
import active_account from "../../assests/images/active-account.svg";
import { customerOnboardingAPI } from "../../api/LeadApi";
const ActivateAccountModal = ({
  showAccoountModal,
  setShowAccoountModal,
  selectedCustomerDetails,
  fetchLeadList,
}) => {
  const activateAccount = async () => {
    const response = await customerOnboardingAPI.activateAccount(
      selectedCustomerDetails?.customerId
    );
    if (response?.status) {
      message.success("Account activated!");
      handleClose();
      fetchLeadList();
    } else {
      message.error(
        response?.response?.data?.message || "Failed to activate account!"
      );
    }
  };
  const handleClose = () => setShowAccoountModal(false);
  return (
    <>
      <Modal
        open={showAccoountModal}
        onCancel={handleClose}
        footer={null}
        // closable={false}
        centered
        maskClosable
      >
        <div style={{ textAlign: "center", padding: "20px 0" }}>
          <img src={active_account} alt="Activate Account" />
          <p
            style={{ color: "#202124", fontWeight: "500", fontSize: "16px" }}
            className="mb-1 mt-2"
          >
            Welcome to SMCS,
          </p>
          <p style={{ color: "#2E77D0" }}>{selectedCustomerDetails?.emails}</p>
          <p style={{ color: "#202124", fontWeight: "400", fontSize: "14px" }}>
            To activate your account, please click on the button below to verify
            your email address. Once activated, you will have full access to
            SMCS application.
          </p>
          <div className="center mt-2">
            <Button className="save-btn" onClick={() => activateAccount()}>
              ACTIVATE ACCOUNT
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ActivateAccountModal;
